import React from 'react';

import { View } from './finsightEntity.view';
import { FinsightEntityPageProps } from './types';

export default function FinsightEntityPage(props: FinsightEntityPageProps) {
  return <View {...props} />;
}
